export const API_URL = (process.env.REACT_APP_ENV == 'prod')?'https://conqerapi.techwagger.in/api/':'http://localhost:8080/conqer/api/';
export const TEST_SITE_KEY = '6LdTBOQqAAAAABce0GFa-hL21yRNOxKjXuQWuWNL';// old -'6Lfhh08dAAAAAJZ-XefQJZvpaN22Lg3uSI3IdDhR';
//export const STRIPE_KEY = (process.env.REACT_APP_ENV == 'prod')?'pk_live_aK2l7GnnFrw2Vuo1ZKTM8qID00wsOtenVC':'pk_test_uKESsWbCiZdkkCcR06R3rqAL00aeeIK7uw';
//test purpose
export const STRIPE_KEY = (process.env.REACT_APP_ENV == 'prod')?'pk_test_uKESsWbCiZdkkCcR06R3rqAL00aeeIK7uw':'pk_test_uKESsWbCiZdkkCcR06R3rqAL00aeeIK7uw';
export const ISRCCODE_AMOUNT = '100';
export const GOOGLE_API_KEY = 'AIzaSyAeY8IgBtkp17ZjUajVLWDP_Lh1gUN0d-0';


